import React from 'react';
export const FlexFiller = () => React.createElement("div", { style: { flex: 1 } });
